<div class="datepicker" [class]="datepickerClasses()">
  @if (labelText()) {
    <label class="datepicker__label">
      {{ labelText() }}
      @if (isRequired()) {
        <span class="datepicker__required">*</span>
      }
    </label>
  }

  <div class="datepicker__container">
    <mat-form-field class="datepicker__form-field" appearance="outline">
      <input
        matInput
        [matDatepicker]="picker"
        [formControl]="control()"
        [placeholder]="placeholderText()"
        [readonly]="isReadonly()"
        [min]="config().min"
        [max]="config().max"
        class="datepicker__input"
        [class]="inputClasses()"
        (dateChange)="onDateChange($event.value)"
        (dateInput)="onDateChange($event.value)"
      />

      @if (showIcon()) {
        <mat-datepicker-toggle matIconSuffix [for]="picker">
          <mat-icon matDatepickerToggleIcon>calendar_today</mat-icon>
        </mat-datepicker-toggle>
      }

      <mat-datepicker
        #picker
        [startView]="config().startView || 'month'"
        (opened)="onOpened()"
        (closed)="onClosed()"
        [panelClass]="panelClass()"
      ></mat-datepicker>
    </mat-form-field>
  </div>

  @if (helperText() && !hasError()) {
    <div class="datepicker__helper-text">{{ helperText() }}</div>
  }

  @if (hasError() && errorText()) {
    <div class="datepicker__error-text">{{ errorText() }}</div>
  }

  @if (hasError() && !errorText()) {
    <div class="datepicker__error-text">Data inválida</div>
  }
</div>
